<div class="dashboard--module-header">
    <h2 class="subheading-sm">Meter reading frequency<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<read-data-availability-consumption-chart class="block-chart" [(hasData)]="hasData" [(hasLoading)]="hasLoading" *ngIf="hasLoading || hasData; else noData"></read-data-availability-consumption-chart>
<ng-template style="text-align:center" #noData><p class="text-center">No data available</p></ng-template>


